import React from 'react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

import classes from './ChallengeStatus.module.scss';
import { Status } from '../../../../../../shared/components/ui-components';
import {
  type ChallengeStatusType,
  CHALLENGE_STATUS,
} from '../../../../../constants/challengeStatus';
import { getFormattedLocalDate } from '../../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../../shared/constants/apiDateFormat';

type ChallengeStatusProps = {
  status: ChallengeStatusType;
  startDate: string | null;
  endDate: string | null;
};

const ChallengeStatus = ({ status, startDate, endDate }: ChallengeStatusProps) => {
  const formattedStartDate = startDate
    ? getFormattedLocalDate(startDate, localDataFormat)
    : '-';
  const formattedEndDate = endDate
    ? getFormattedLocalDate(endDate, localDataFormat)
    : '-';
  switch (status) {
    case CHALLENGE_STATUS.ACTIVE:
      return (
        <Status icon={<CheckCircleRoundedIcon fontSize="small" color="success" />}>
          <div className={classes.statusWithDescription}>
            Active
            <span className={classes.description}>
              Starts from {formattedStartDate} to {formattedEndDate}
            </span>
          </div>
        </Status>
      );
    case CHALLENGE_STATUS.DRAFT:
      return (
        <Status icon={<FileCopyRoundedIcon fontSize="small" color="info" />}>
          Draft
        </Status>
      );
    case CHALLENGE_STATUS.FINISHED:
      return (
        <Status icon={<DoneAllRoundedIcon fontSize="small" color="tertiary" />}>
          Finished
        </Status>
      );
    case CHALLENGE_STATUS.PUBLISHED:
      return (
        <Status
          icon={
            <SendRoundedIcon
              fontSize="small"
              color="warning"
              className={classes.publishedIcon}
            />
          }
        >
          <div className={classes.statusWithDescription}>
            Published
            <span className={classes.description}>Starts from {formattedStartDate}</span>
          </div>
        </Status>
      );
    default:
      return null;
  }
};

export { ChallengeStatus };
